<template>
  <div>
    <v-row>
      <v-col>
        <CustomerLocationsComponent :types="types" :areas="areas" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <CustomerLocationAreasComponent @loaded="(value) => areas = value" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <CustomerLocationTypesComponent @loaded="onTypesLoaded" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CustomerLocationsComponent from '@/components/customer/CustomerLocationsComponent.vue';
import CustomerLocationAreasComponent from '@/components/customer/CustomerLocationAreasComponent.vue';
import CustomerLocationTypesComponent from '@/components/customer/CustomerLocationTypesComponent.vue';

export default {
  name: 'CustomerLocations',
  components: {
    CustomerLocationsComponent,
    CustomerLocationAreasComponent,
    CustomerLocationTypesComponent
  },
  props: ['customer'],
  data() {
    return {
      types: [],
      areas: []
    }
  },
  methods: {
    onTypesLoaded: function(value) {
      this.types = value;
    }
  }
}
</script>